// removed by extract-text-webpack-plugin
module.exports = {"picker":"_1ZelkG4KdV8400vzpyYcsI","pick":"_3NDJSXWwtcZzncuFHXmQKu"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ArticlePicker/style.scss
// module id = 955
// module chunks = 0